import { h } from 'preact';
import clsx from 'clsx';
import ThreekitIcons from '../threekit-icons';
import { useThreekit } from '../../threekit-context';
import { useModal } from '../../modal-context';
import InspoButton from '../inspo-button';
import HelpButton from '../help-button';
import FullScreenButton from '../../full-screen-button';
import ThreekitMenuButton from '../../threekit-menu-button';
import { socialShareModalName } from './social-share-modal';

function MobileToolbarModal() {
  const { darkMode } = useThreekit();
  const { closeModal, modalName, openModal } = useModal();

  if (modalName !== 'Mobile Toolbar') {
    return null;
  }

  return (
    <div className="flex flex-1 flex-col gap-3 w-full px-[10px] mt-3 relative">
      <p
        className={clsx('text-left heading-6', {
          'text-white': darkMode,
          'text-black': !darkMode,
        })}
      >
        tools
      </p>

      <div className="flex gap-[7px]">
        <HelpButton />
        <InspoButton />
        <button
          onClick={() => openModal(socialShareModalName)}
          className={clsx(
            'flex items-center justify-center w-[38px] h-[38px] text-center border-[0.6px] rounded cursor-pointer',
            {
              'border-black text-black hover:bg-dynamic hover:text-white':
                !darkMode,
              'border-white text-white hover:bg-bg-1 hover:text-black':
                darkMode,
            },
          )}
        >
          <ThreekitIcons type="share" />
        </button>
        <FullScreenButton
          className={clsx(
            'flex items-center justify-center w-[38px] h-[38px] text-center border-[0.6px] rounded cursor-pointer',
            {
              'border-black text-black hover:bg-dynamic hover:text-white':
                !darkMode,
              'border-white text-white hover:bg-bg-1 hover:text-black':
                darkMode,
            },
          )}
        />
        <ThreekitMenuButton
          className={clsx(
            'flex items-center justify-center w-[38px] h-[38px] text-center border-[0.6px] rounded cursor-pointer',
            {
              'border-black text-black hover:bg-dynamic hover:text-white':
                !darkMode,
              'border-white text-white hover:bg-bg-1 hover:text-black':
                darkMode,
            },
          )}
        />
      </div>
      <button
        onClick={() => closeModal()}
        type="button"
        className="absolute top-0 right-[10px] -translate-y-1/4"
      >
        <ThreekitIcons type="exitIcon" />
      </button>
    </div>
  );
}

export default MobileToolbarModal;
